<template>
    <div :id="`voiceMessagePlayer`" class="sc-message--text" ref="voiceMessage">
        <div @click="toggleAudio()">
            <md-icon id="playButton">{{ paused ? "play_circle" : "pause_circle" }}</md-icon>
        </div>
        <av-waveform
            id="waveform"
            :playtime="false"
            :playtimeWithMs="false"
            :playtimeTextBottom="false"
            :playtimeSliderWidth="3"
            :noplayedLineColor="'#999999'"
            :played-line-color="'#6098ff'"
            :audio-src="getSrc()"
            :playtimeFontSize="0"
            :canvWidth="200"
            :canvHeight="40"
            :played-line-width="0.3"
            :noplayed-line-width="0.3"
            :playtime-slider-color="'#4E8CFF'"
        ></av-waveform>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "VoiceMessage",
    props: ["data"],
    data: () => ({
        paused: true,
    }),
    computed: {
        ...mapState({
            isDarkMod: (state) => state.app.darkMode,
        }),
    },
    methods: {
        getSrc() {
            const asset = this.data.asset;
            const isWhatsapp = asset.path.indexOf("whatsapp") !== -1;
            const isInstagram = asset.path.indexOf("instagram") !== -1;
            const isMessenger = asset.path.indexOf("messenger") !== -1;
            const isTelegram = asset.path.indexOf("telegram") !== -1;
            const src =
                isWhatsapp || isInstagram || isTelegram || isMessenger
                    ? `https://static.supsis.live/${asset.path}`
                    : `https://static.supsis.live/${asset.path + asset._id}${asset.ext ? "." + asset.ext : ""}`;
            return src;
        },
        toggleAudio() {
            const audio = this.$refs.voiceMessage.querySelector(`audio`);
            audio[audio?.paused ? "play" : "pause"]();
            this.paused = !this.paused;
        },
    },
};
</script>

<style lang="scss" scoped>
#voiceMessagePlayer > :nth-child(2) > :nth-child(1) {
    display: none;
}

#voiceMessagePlayer {
    display: flex;
    align-items: center;
    padding: 4px;
    background-color: transparent;

    i.md-icon {
        font-style: normal !important;
        background-color: none !important;
        padding: 0 !important;
        margin-right: 4px;
        color: #4e8cff;
    }

    &::after {
        display: none;
    }
}

#waveform {
    margin-right: 20px;
    padding: 0 10px 0 20px;
    background-color: #ededed;
    border-radius: 25px;
}

.sc-message--text {
    background-color: transparent;
}
</style>
